const isPasswordValid = (password) => {
  return password.length >= 8;
};

export default isPasswordValid;
